<div class="or-pt-32-px or-mx-24-px action-push-modal">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center"
      >Polecaj aplikacje Orlikfy, zbieraj dodatkowe punkty!</span
    >
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/referral.jpg" />

  <div class="or-mb-20-px or-text-lg">
    W Orlikfy punkty wpadają nie tylko za grę Chcesz zgarnąć więcej? Zapraszaj znajomych do aplikacji!
  </div>
  <div class="or-mb-20-px or-text-lg">
    Wystarczy, że znajdziesz swój kod polecający w profilu i przekażesz go znajomym. Gdy użyją go w edycji profilu,
    oboje otrzymacie punkty, które później wymienicie na atrakcyjne rabaty!
  </div>
  <div class="or-mb-20-px or-text-lg">Proste, szybkie i korzystne – zaproś ekipę i zbieraj nagrody!</div>
</div>

<div class="or-mb-12-px or-mx-24-px or-mt-12-px">
  <button class="button-primary-style or-h-48-px or-head-md or-w-100-pc or-mb-12-px" (click)="handleAction()">
    Przejdź do kodu
  </button>

  <button class="button-secondary-style or-h-48-px or-head-md or-w-100-pc" (click)="closeModal()">
    Wróć do głównego ekranu
  </button>
</div>
